import ApiService from "./ApiService";
import { getCookie } from "./CommonService";
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./basequery";

const servicePrefix = "/models";

const csrftoken = getCookie("csrftoken");

export const modelService = createApi({
  reducerPath: "modelApi",
  baseQuery,
  refetchOnFocus: true,
  refetchOnReconnect: true,
  refetchOnMountOrArgChange: true,
  tagTypes: ["models"],
  endpoints: (build) => ({
    exportModel: build.mutation({
      query: ({ ...values }) => ({
        url: `${servicePrefix}/deploy/`,
        method: "post",
        data: { ...values },
      }),
    }),
    getExportedModels: build.query({
      query: () => ({
        url: `${servicePrefix}/manage-model/`,
      }),
      providesTags: (result) =>
        result?.results
          ? [
              ...result?.results?.map?.(({ id }) => ({
                type: "models",
                id,
              })),
              { type: "models", id: "LIST" },
            ]
          : [{ type: "models", id: "LIST" }],
    }),
    deleteModel: build.mutation({
      query: ({ id }) => ({
        url: `${servicePrefix}/manage-model/${id}/`,
        method: "delete",
      }),
      invalidatesTags: [{ type: "models", id: "LIST" }],
    }),
    updateModel: build.mutation({
      query: ({ id, ...values }) => ({
        url: `${servicePrefix}/manage-model/${id}/`,
        method: "patch",
        data: { ...values },
      }),
      invalidatesTags: [{ type: "models", id: "LIST" }],
    }),
  }),
});

export const {
  useExportModelMutation,
  useGetExportedModelsQuery,
  useDeleteModelMutation,
  useUpdateModelMutation
} = modelService;

export async function apiExportModel(data) {
  return ApiService.fetchData({
    url: servicePrefix + "/deploy/",
    method: "post",
    data,
  });
}
